import sortableJs from 'sortablejs'
import csrf from './csrf'
import $ from 'jquery'

import yp from './yp'

function handler(e) {
  if (e.to != e.from) {
    log.warn('Dragging to a different list is not supported!');
    return
  }
  var $el = $(e.to)
  var updateUrl = $el.data('update-url')
  if (_.isEmpty(updateUrl) || !_.isString(updateUrl)) {
    console.warn('No data-update-url defined in el or not a string')
    return
  }
  var parameterName = $el.data('param-name')
  if (_.isEmpty(parameterName) || !_.isString(parameterName)) {
    console.warn('No data-param-name defined in el or not a string')
    return
  }
  var data = {}
  data[parameterName] = $el.find('div.item-id').map(function (idx, e) {
    return $(e).data('value')
  }).get()
  $el.data('y').option('disabled', true)
  $el.addClass('page-disabled')
  $.ajax({
    url: updateUrl,
    type: 'POST',
    dataType: 'json',
    headers: csrf(),
    success: function (data, textStatus, jqXHR) {
      if (data.result == 'error') {
        console.log('i need to move ' + e.newIndex + ' to old position ' + e.oldIndex)
        a = $el.data('y').toArray()
        ne = a[e.newIndex]
        a.splice(e.newIndex, 1)
        a.splice(e.oldIndex, 0, ne)
        $el.data('y').sort(a)
      }
      yp.showMessages(data)
    },
    error: function (jqXHR, statusText, errorThrown) {
      yp.handleAjaxError(jqXHR, statusText, errorThrown)
    },
    complete: function (jqXHR, textStatus) {
      $el.data('y').option('disabled', false)
      $el.removeClass('page-disabled')
    },
    data: data,
    context: $el,
  })
}

export default function sortable(elem) {
  console.log('sortable::', elem)
  $(elem).data('y', sortableJs.create($(elem)[0], {
    handle: 'tr',
    forceFallback: true,
    animation: 150,
    onUpdate: handler,
  }))
}
